import { ResourceLanguage } from 'i18next';
import { TranslationExtensionInterface } from '../interface/translation.extension.interface';

export class BikeleasingTranslationExtension extends TranslationExtensionInterface {
  moduleName = 'bikeleasing_v2';
  get translations(): ResourceLanguage {
    return {
      de: {
        title: 'Bikeleasing',
        activationDialog: {
          activationHint: '*Wenn Sie diesen Benefit freischalten, bekommen Ihre Mitarbeiter diesen in der Mitarbeiter-App angezeigt.',
          changeOptionsInfo:
            'Wenn Sie die aktuellen Konditionen für Ihr Unternehmen anpassen möchten, können Sie dies jederzeit <settings>in den Einstellungen</settings> vornehmen.',
          createTitle: 'Benefit für Mitarbeiter freischalten',
          bulkCreateTitle: 'Benefit für Mitarbeiter freischalten',
        },
        insurance: {
          infoTooltip: 'Zum Ablaufplan der Versicherung',
          title: 'Arbeitgeber-Ausfallversicherung',
          pageText:
            'Die Arbeitgeber-Ausfallversicherung bietet Arbeitgebern Schutz bei Vorfällen mit Mitarbeitern, die ein Dienstrad nutzen. So besteht beispielsweise die Möglichkeit einer Erstattung, wenn der Mitarbeiter aufgrund von Krankheit oder Unfall arbeitsunfähig ist, sowie einer vorzeitigen Rückgabe der Diensträder bei Kündigung oder einvernehmlicher Auflösung des Arbeitsverhältnisses sowie bei dauerhafter Arbeitsunfähigkeit oder Tod des Mitarbeiters.<br><br/>Als zusätzliche Absicherung besteht die Möglichkeit, das Dienstrad während der Elternzeit (einschließlich Mutterschutz) zurückzugeben und damit den Vertrag zu kündigen, oder sich für eine Erstattung der gesamten Leasingraten für bis zu 18 Monate zu entscheiden.',
          reportInsuranceClaim: 'Versicherungsfall melden',
          viewAllOpenCases: 'Alle offenen Fälle anzeigen',
          viewAllClosedCases: 'Alle geschlossenen Fälle anzeigen',
          comfort: 'Komfort-Versicherung',
          wearAndTear: 'Verschleiß-Versicherung',
          inspectionPackage: 'Inspektionspaket',
        },
        contract: {
          approveReject: 'Freigeben / Ablehnen',
          accessories: {
            optionalAccessoriesRequested: 'Optionales Zubehör angefordert',
            lockBrand: 'Schlossmarke',
            typeOfLock: 'Schlosstyp',
          },
          claimInsuranceCase: 'Versicherungsfall melden',
          contractDetailsHeadline: 'Bikeleasing Vertragsdaten',
          bike: {
            frameNumber: 'Rahmennummer',
            frameHeight: 'Rahmengröße',
            bikeType: 'Fahrradtyp',
            basicColor: 'Basisfarbe',
          },
          employeeUserId: 'Bikeleasing Mitarbeiter User ID',
          deliveryDate: 'Lieferdatum',
          documents: {
            title: 'Downloads',
            elv: 'Leasingvertrag',
            transferAgreement: 'Überlassungsvertrag',
            elvNotAvailable: 'Leasingvertrag nicht verfügbar',
            transferAgreementNotAvailable: 'Überlassungsvertrag nicht verfügbar',
            elvDownloadError: 'Leasingvertrag konnte nicht heruntergeladen werden',
            transferAgreementDownloadError: 'Überlassungsvertrag konnte nicht heruntergeladen werden',
          },
          logisticData: 'Logistikdaten',
          monthlyLeasingRate: 'Monatliche Leasingrate',
          monetaryAdvantage: 'Geldwerter Vorteil Fahrrad',
          insuranceCoverage: {
            label: 'Versicherungsschutz',
          },
          recommendedRetailPrice: 'UVP',
          purchasePrice: 'Kaufpreis',
          reportBikeDamage: 'Fahrradschaden melden',
          requestEarlyBuyoutOffer: 'Vorzeitiges Ablöseangebot',
          retailer: 'Online-/Lieferhändler',
          signContract: 'Vertrag unterzeichnen',
        },
        contractsTable: {
          startDownload: 'Vertragsliste herunterladen',
          prepareDownload: 'Vertragsliste wird vorbereitet',
          downloadReady: 'Vertragsliste herunterladen',
        },
        pendingOnboarding:
          'Sollten Sie sich bereits im Onboarding-Prozess befinden und Fragen zu Ihrem Status haben, steht Ihnen Ihr persönlicher Kundenbetreuer gerne zur Verfügung.',
        pendingOnboardingCaption:
          'Ausführliche Angaben zu unserer Datenverarbeitung finden Sie in unseren <0>Datenschutzinformationen</0>.',
        settings: {
          title: 'Einstellungen',
          infoTitle: 'Einstellungen für das Unternehmensprofil',
          infoText:
            'Bearbeiten Sie Ihr Unternehmensprofil, passen Sie die Leasingbedingungen an und legen Sie Preisgrenzen für Fahrräder fest.<br/>Alle Einstellungen finden Sie auf der entsprechenden',
          infoAction: 'Einstellungsseite',
          caption: 'Verwalten Sie hier Ihre Bikeleasing-Benefit-Einstellungen für <bold>Ihren Firmencode {{companyCode}}</bold>.',
          info: 'Alle relevanten Informationen über unsere Versicherungen finden Sie <0>hier</0>.',
          bikeTypes: {
            fahrrad: 'Fahrrad',
            pedelec: 'Pedelec',
            spedelec: 'S-Pedelec',
          },
          bikeParameters: {
            title: 'Fahrradparameter',
            bikeTypes: 'Fahrradtypen',
            maxNumberBikesPerEmployee: 'Max. Anzahl Fahrräder pro Mitarbeiter',
            maxAmountPerEmployee: 'Max. Betrag € pro Mitarbeiter für alle Fahrräder',
            minBikePrice: 'Min. Betrag € pro Fahrrad',
            maxBikePrice: 'Max. Betrag € pro Fahrrad',
            minBikePriceExceedsMax: 'Der Min. Betrag darf den Max. Betrag nicht überschreiten',
            maxBikePriceBelowMin: 'Der Max. Betrag darf nicht kleiner als der Min. Betrag sein',
          },
          leasingParameters: {
            title: 'Leasingparameter',
            leasingPeriodsMonths: 'Leasingdauer in Monaten',
            currentLeasingFactor36Months: 'Leasingfaktor (36 Monate)',
            currentLeasingFactor48Months: 'Leasingfaktor (48 Monate)',
            inputTaxDeductible: 'Vorsteuerabzugsberechtigung',
            rateWillBeTakenOverCompletely: 'Rate wird vollständig übernommen',
            employerShareAbsolute: 'Absoluter Arbeitgeberanteil an der Leasingrate €',
            employerSharePercentage: 'Prozentualer Arbeitgeberanteil an der Leasingrate',
          },
          insuranceParametersEmployee: {
            title: 'Versicherungsparameter – Arbeitnehmerschutz',
          },
          insuranceParametersEmployer: {
            title: 'Versicherungsparameter – Arbeitgeberschutz',
          },
          insuranceModules: {
            comfort: 'Bikeleasing-Komfort-Versicherung',
            wearAndTear: 'Bikeleasing-Verschleiß-Versicherung',
            inspection: 'Bikeleasing-Inspektionspaket',
            downtimePremium: 'Bikeleasing-Arbeitgeber-Ausfallversicherung',
            downtimePremiumPlus: 'Bikeleasing-Arbeitgeber-Ausfallversicherung Plus',
            liabilityLegal: 'Bikeleasing-Haftpflicht-& Rechtsschutzversicherung',
          },
          paidBy: {
            employer: 'Getragen durch Arbeitgeber',
            employee: 'Getragen durch Arbeitnehmer',
            bls: 'Getragen durch Bikeleasing',
            included_in_leasing_rate: 'In Leasingrate enthalten',
          },
          status: {
            active: 'Aktiv',
            inactive: 'Inaktiv',
          },
        },
        marketingDialog: {
          title: 'Willkommen bei Probonio',
          description:
            '<b>Ihr innovatives Portal für moderne Benefits.</b>\nUnsere Software macht es einfacher denn je, vielfältige Benefits in wenigen Schritten zu integrieren und zu verwalten.\nStarten Sie jetzt mit den Einführungsschritten hinter dem Glühbirnen-Icon, hilfreiche Informationen und Tipps finden Sie zudem in unserem <helpCenter>Probonio Helpcenter</helpCenter>.\n\n<b>Sie nutzen bereits Bikeleasing?</b>\nWenn Ihr Unternehmen Bikeleasing anbietet, sind die entsprechenden Daten wie Mitarbeiter, Verträge und mehr bereits für Sie vorbereitet und können direkt in der Mitarbeiter-App genutzt werden.\nPro-Tipp: Sie können die angezeigten Benefits jederzeit in der <manager>Mitarbeiterverwaltung</manager> anpassen und mit smarten <template>Vorlagen</template> automatisiert neuen Mitarbeitern zuteilen.',
          legalText:
            'Ich willige ein, dass mich die Unternehmen der BLS Beteiligungs GmbH über interessante Angebote und Neuigkeiten in den Bereichen Mitarbeiter-Benefits, Dienstrad-Leasing, Versicherungen und Gebrauchtrad-Handel persönlich informieren und beraten. Meine Einwilligung ist freiwillig und kann jederzeit widerrufen werden. <site>Details einblenden</site>.',
          imageAlt: 'Bikeleasing Marketing Bild',
          error: 'Beim Speichern Ihrer Einwilligung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
          button: 'Jetzt loslegen',
        },
        information: {
          title: 'Informationen & Support',
          leasingCalculator: {
            title: 'Leasingrechner',
            description:
              'Unser Leasingrechner zeigt in wenigen Klicks, wie sich Fahrradpreis, Leasingrate und Versicherungsoptionen zusammensetzen – zur eigenen Orientierung oder zur Weitergabe innerhalb Ihres Unternehmens. Auch Mitarbeiter können ihn direkt nutzen. So entsteht Transparenz ohne zusätzlichen Aufwand für Sie.',
            buttonText: 'Zum Leasingrechner',
          },
          dealerMap: {
            title: 'Händlersuche',
            description:
              'Ob beim Fachhändler vor Ort oder bequem online: Mit der Bikeleasing-Händlersuche finden Ihre Mitarbeiter selbstständig den passenden Anbieter. Eine breite Auswahl an Fachhändlern und Marken ermöglicht einen reibungslosen und einfachen Bestellprozess.',
            buttonText: 'Zur Händlersuche',
          },
          resources: {
            title: 'Ressourcen',
            insurance: 'Versicherungshandbuch',
            damage: 'Ablauf im Schadenfall',
            faq: 'FAQ',
            messages: 'Schreib uns auf WhatsApp',
          },
          contacts: {
            title: 'Support',
            support: 'Support',
            insurance: 'Radversicherung',
            agv: 'Arbeitgeber-Ausfallversicherung',
            buyout: 'Ablöse',
            dealerSupport: 'Händler-Support',
            logistics: 'Logistik',
          },
          news: {
            title: 'Neues von Bikeleasing',
            buttonText: 'Alle anzeigen',
            noData: { list: 'Derzeit sind keine Einträge vorhanden', details: 'Der Artikel konnte nicht gefunden werden' },
          },
        },
        terminationDialog: {
          terminationNotPossible: `Das Arbeitsverhältnis kann nicht zum gewählten Termin beendet werden, da der Bikeleasingvertrag zu dem Zeitpunkt noch aktiv ist. Bitte melden Sie die Kündigung hier über die <0>{{managerAgavPage}}</0>.`,
        },
        payroll: {
          salaryTypeBikeleasingBenefitInKind: 'Lohnart Firmenrad stpfl.',
          salaryTypeBikeleasingBenefitInKindHelper: 'Diese Lohnart wird für die Abrechnung des Bikeleasing-Benefits verwendet',
          salaryTypeBikeleasingSalaryConversion: 'Lohnart Gehaltsumwandlung',
          salaryTypeBikeleasingSalaryConversionHelper: 'Diese Lohnart wird für die Abrechnung des Bikeleasing-Benefits verwendet',
        },
        integration: {
          title: 'Nur noch ein Schritt',
          description: 'Vervollständigen Sie bitte Ihre Daten um Vertragsunterlagen anzufragen',
          form: {
            olderThan1Year: 'Mein Unternehmen besteht seit mindestens einem Jahr.',
            error: 'Beim Absenden Ihrer Daten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
          },
          success: {
            title: 'Vielen Dank für Ihre Anfrage!',
            description: 'Das Bikeleasing-Team kontaktiert Sie möglichst schnell per E-Mail oder telefonisch.',
          },
        },
        support: {
          title: 'Bikeleasing',
          subtitle: 'Support zum Bikeleasing-Benefit',
          employerInsurance: 'Arbeitgeber-Ausfallversicherung',
          bikeInsurance: 'Radversicherung',
          otherTopics: 'Weitere Bikeleasing-Themen',
          writeChatbotOnWA: 'Chatbot auf WhatsApp kontaktieren',
        },
      },
      en: {
        title: 'Bikeleasing',
        activationDialog: {
          activationHint: '*When you activate this benefit, your employees will see it displayed in the employee app.',
          changeOptionsInfo:
            'If you would like to adjust the current conditions for your company, you can do so at any time <settings>in the settings</settings>.',
          createTitle: 'Activate benefit for employee',
          bulkCreateTitle: 'Activate benefit for employees',
        },
        insurance: {
          infoTooltip: 'Go to insurance plan PDF',
          title: 'Employer Indemnity Insurance',
          pageText: `The Bikeleasing Indemnity Insurance provides protection for employers in the event of an incident involving an employee who uses a company bike. For example, there is the option of reimbursement in case the employee is unable to work due to illness or accident, early return of company bikes in the event of termination or mutual agreement, as well as in the case of the employee's permanent disability or death.<br/><br>As an additional safeguard, there is the option to return the company bike during parental leave (including maternity protection) and thus terminate the contract or to choose reimbursement of the total leasing installments for up to 18 months.`,
          reportInsuranceClaim: 'Report insurance claim',
          viewAllOpenCases: 'View all open cases',
          viewAllClosedCases: 'View all closed cases',
          comfort: 'Comfort Insurance',
          wearAndTear: 'Wear and Tear Insurance',
          inspectionPackage: 'Inspection Package',
        },
        contract: {
          approveReject: 'Approve / Reject',
          accessories: {
            optionalAccessoriesRequested: 'Optional accessories requested',
            lockBrand: 'Lock brand',
            typeOfLock: 'Type of lock',
          },
          claimInsuranceCase: 'Claim insurance case',
          contractDetailsHeadline: 'Bikeleasing contract data',
          bike: {
            bikeType: 'Bike type',
            basicColor: 'Basic color',
            frameNumber: 'Frame number',
            frameHeight: 'Frame height',
          },
          employeeUserId: 'Bikeleasing Employee User ID',
          deliveryDate: 'Delivery date',
          documents: {
            title: 'Downloads',
            elv: 'Contract',
            transferAgreement: 'Leasing Agreement',
            elvNotAvailable: 'Contract not available',
            transferAgreementNotAvailable: 'Leasing Agreement not available',
            elvDownloadError: 'Downloading the contract failed',
            transferAgreementDownloadError: 'Downloading the leasing agreement failed',
          },
          logisticData: 'Logistic data',
          monthlyLeasingRate: 'Monthly leasing rate',
          monetaryAdvantage: 'Monetary advantage bike',
          insuranceCoverage: {
            label: 'Insurance coverage',
          },
          recommendedRetailPrice: 'RRP',
          purchasePrice: 'Purchase Price',
          reportBikeDamage: 'Report bike damage',
          requestEarlyBuyoutOffer: 'Early buyout offer',
          retailer: 'Online/Delivery retailer',
          signContract: 'Sign contract',
        },
        contractsTable: {
          startDownload: 'Download contract list',
          prepareDownload: 'Preparing contract list',
          downloadReady: 'Download contract list',
        },
        pendingOnboarding:
          'If you are already in the onboarding process and have questions about your status, your personal account manager will be happy to assist you.',
        pendingOnboardingCaption: 'Detailed information about our data processing can be found in our <0>privacy policy</0>.',
        settings: {
          title: 'Settings',
          infoTitle: 'Company Profile Settings',
          infoText:
            'Edit your company profile, adjust leasing conditions and define bike price limits.<br/>All settings can be updated on the corresponding',
          infoAction: 'Settings page',
          caption: 'Manage your Bikeleasing benefit settings for <bold>your company code {{companyCode}}</bold> here.',
          info: 'All relevant information about insurances can be found <0>here</0>.',
          bikeTypes: {
            fahrrad: 'Bike',
            pedelec: 'Pedelec',
            spedelec: 'S-Pedelec',
          },
          bikeParameters: {
            title: 'Bike parameters',
            bikeTypes: 'Bike types',
            maxNumberBikesPerEmployee: 'Max. number of bikes per employee',
            maxAmountPerEmployee: 'Max. amount € per employee for all bikes',
            minBikePrice: 'Min amount € per bike',
            maxBikePrice: 'Max amount € per bike',
            minBikePriceExceedsMax: 'The min. amount must not exceed the max. amount',
            maxBikePriceBelowMin: 'The max. amount must not be lower than the min. amount',
          },
          leasingParameters: {
            title: 'Leasing parameters',
            leasingPeriodsMonths: 'Leasing period in months',
            currentLeasingFactor36Months: 'Leasing factor (36 months)',
            currentLeasingFactor48Months: 'Leasing factor (48 months)',
            inputTaxDeductible: 'Entitlement to deduct input tax',
            rateWillBeTakenOverCompletely: 'Rate is fully covered',
            employerShareAbsolute: "Employer's absolute share of lease rate €",
            employerSharePercentage: "Employer's percentage share of lease rate",
          },
          insuranceParametersEmployee: {
            title: 'Insurance parameters - Employee protection',
          },
          insuranceParametersEmployer: {
            title: 'Insurance parameters - Employer protection',
          },
          insuranceModules: {
            comfort: 'Bikeleasing comfort Insurance',
            wearAndTear: 'Bikeleasing wear and tear Insurance',
            inspection: 'Bikeleasing Inspection Package',
            downtimePremium: 'Bikeleasing Employer indemnity Insurance',
            downtimePremiumPlus: 'Bikeleasing Employer indemnity Insurance Plus',
            liabilityLegal: 'Bikeleasing Liability & Legal protection Insurance',
          },
          paidBy: {
            employer: 'Covered by employer',
            employee: 'Covered by employee',
            bls: 'Covered by Bikeleasing',
            included_in_leasing_rate: 'Included in leasing rate',
          },
          status: {
            active: 'Active',
            inactive: 'Inactive',
          },
        },
        marketingDialog: {
          title: 'Welcome to Probonio',
          description:
            '<b>Your innovative portal for modern benefits.</b>\nOur software makes it easier than ever to integrate and manage a wide range of benefits in just a few steps.\nGet started with the introduction steps behind the light bulb icon. You can also find helpful information and tips in our <helpCenter>Probonio Helpcenter</helpCenter>.\n\n<b>Already using bikeleasing?</b>\nIf your company offers bikeleasing, the relevant data like employees, contracts and more is already prepared for you and can be used directly in the employee app.\nPro tip: You can customize the benefits displayed at any time in the <manager>employee management page</manager> and automatically assign them to new employees using our smart <template>templates</template>.',
          legalText:
            'I agree that the companies of BLS Beteiligungs GmbH may personally inform and advise me about interesting offers and news in the areas of company bike leasing, insurance, employee benefits, and used bike sales. My consent is voluntary and can be revoked at any time. <site>More Details.</site>.',
          imageAlt: 'Bikeleasing Marketing Image',
          error: 'An error occurred while saving your agreement. Please try again later.',
          button: "Let's start",
        },
        information: {
          title: 'Information & Support',
          leasingCalculator: {
            title: 'Leasing Calculator',
            description:
              'Our leasing calculator shows you in just a few clicks how the bike price, leasing rate, and insurance options are calculated—for your own reference or to share within your company. Employees can also use it directly. This creates transparency without any additional effort on your part.',
            buttonText: 'Open Leasing Calculator',
          },
          dealerMap: {
            title: 'Dealer Map',
            description:
              'Whether at a local specialist retailer or conveniently online: with the bikeleasing dealer search, your employees can find the right provider themselves. A wide selection of specialist retailers and brands ensures a smooth and simple ordering process.',
            buttonText: 'Open Dealer Map',
          },
          resources: {
            title: 'Resources',
            insurance: 'Insurance Guide',
            damage: 'Damage claim procedure',
            faq: 'FAQ',
            messages: 'Message us on WhatsApp',
          },
          contacts: {
            title: 'Support',
            support: 'Support',
            insurance: 'Bike Insurance',
            agv: 'Employer Indemnity Insurance',
            buyout: 'Buyout',
            dealerSupport: 'Bike Dealer support',
            logistics: 'Logistics',
          },
          news: {
            title: 'News from Bikeleasing',
            buttonText: 'Show All',
            noData: { list: 'No news available at the moment', details: 'The article could not be found.' },
          },
        },
        terminationDialog: {
          terminationNotPossible: `The employment relationship cannot be terminated on the selected date because the bikeleasing contract is still active at that time. Please report the termination here via the <0>{{managerAgavPage}}</0>.`,
        },
        payroll: {
          salaryTypeBikeleasingBenefitInKind: 'Wage type company bike taxable',
          salaryTypeBikeleasingBenefitInKindHelper: 'This wage type is used for accounting the Bikeleasing benefit',
          salaryTypeBikeleasingSalaryConversion: 'Wage type salary conversion',
          salaryTypeBikeleasingSalaryConversionHelper: 'This wage type is used for accounting for the Bikeleasing benefit',
        },
        integration: {
          title: 'Just one more step',
          description: 'Please complete your details to request contract documents',
          form: {
            olderThan1Year: 'My company has been in existence for at least one year.',
            error: 'An error occurred while submitting your data. Please try again later.',
          },
          success: {
            title: 'Thank you for your request!',
            description: 'The Bikeleasing team will contact you as soon as possible by email or phone.',
          },
        },
        support: {
          title: 'Bikeleasing',
          subtitle: 'Support regarding the bikeleasing benefit',
          employerInsurance: 'Employer Indemnity Insurance',
          bikeInsurance: 'Bike insurance',
          otherTopics: 'Other bikeleasing topics',
          writeChatbotOnWA: 'Write our Chatbot on WhatsApp',
        },
      },
    };
  }
}
